<mat-card appearance="outlined">
  <mat-card-content>
    <p>{{serviceProvider.ID}}</p>
    <p>{{serviceProvider.Name}}</p>
    <button mat-icon-button (click)="startupService.selectRole('serviceProvider', '' + serviceProvider.ID, serviceProvider.Name); router.navigate(['/secure/umbrellas']);"><mat-icon>supervised_user_circle</mat-icon></button>
  </mat-card-content>
</mat-card>
